module.exports = __webpack_public_path__ + "static/img/teaching_2.45aa90b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/welfare/teaching_2.png
// module id = 71yS
// module chunks = 0